<template>
  <!-- Carousel Start -->
    <div class="container-fluid px-0 mb-5">
        <div id="header-carousel" class="carousel slide carousel-fade" data-bs-ride="carousel">
            <div class="carousel-inner">
                <div class="carousel-item active">
                    <img class="w-100" src="@/assets/img/carousel-1.jpg" alt="Image">
                    <div class="carousel-caption">
                        <div class="container">
                            <div class="row justify-content-center">
                                <div class="col-lg-7 text-center">
                                    <p class="fs-4 text-white animated zoomIn">Welcome to <strong class="text-primary">BistroBox NG</strong></p>
                                    <h1 class="display-1 mb-4 animated zoomIn">Where Every Bite Hits Different</h1>
                                    <router-link class="btn btn-light rounded-pill py-3 px-5 animated zoomIn" to="/gallery">View Gallery</router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="carousel-item">
                    <img class="w-100" src="@/assets/img/carousel-2.jpg" alt="Image">
                    <div class="carousel-caption">
                        <div class="container">
                            <div class="row justify-content-center">
                                <div class="col-lg-7 text-center">
                                    <p class="fs-4 text-white animated zoomIn">Bold flavors.  <strong class="text-primary">Freshly made.</strong></p>
                                    <h1 class="display-1 mb-4 animated zoomIn">One Bite More. Every Time.</h1>
                                    <router-link class="btn btn-light rounded-pill py-3 px-5 animated zoomIn" to="/menu">View Menu</router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <button class="carousel-control-prev" type="button" data-bs-target="#header-carousel"
                data-bs-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Previous</span>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#header-carousel"
                data-bs-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Next</span>
            </button>
        </div>
    </div>
    <!-- Carousel End -->


    <!-- About Start -->
    <div class="container-xxl py-5">
        <div class="container">
            <div class="row g-5">
                <div class="col-lg-6">
                    <div class="row g-3">
                        <div class="col-6 text-end">
                            <img class="img-fluid bg-white w-100 mb-3 wow fadeIn" data-wow-delay="0.1s" src="@/assets/img/about-1.jpg" alt="">
                            <img class="img-fluid bg-white w-50 wow fadeIn" data-wow-delay="0.2s" src="@/assets/img/about-3.jpg" alt="">
                        </div>
                        <div class="col-6">
                            <img class="img-fluid bg-white w-50 mb-3 wow fadeIn" data-wow-delay="0.3s" src="@/assets/img/about-4.jpg" alt="">
                            <img class="img-fluid bg-white w-100 wow fadeIn" data-wow-delay="0.4s" src="@/assets/img/about-2.jpg" alt="">
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 wow fadeIn" data-wow-delay="0.5s">
                    <div class="section-title">
                        <p class="fs-5 fw-medium fst-italic text-primary">About Us</p>
                        <h1 class="display-6">
                            Crafting unforgettable meals that keep you coming back for one bite more.
                        </h1>
                    </div>
                    <div class="row g-3 mb-4">
                        <div class="col-sm-4">
                            <img class="img-fluid bg-white w-100" src="@/assets/img/about-5.jpg" alt="">
                        </div>
                        <div class="col-sm-8">
                            <h5>Our meals are among the most loved comfort foods, from burgers to wings and fries.</h5>
                            <p class="mb-0">
                                Every meal is prepared with care, flavor, and consistency — from our burgers to our wings and fries.
                            </p>
                        </div>
                    </div>
                    <div class="border-top mb-4"></div>
                    <div class="row g-3">
                        <div class="col-sm-8">
                            <h5>Exotic meals you won't get at your everyday Nigerian eatery</h5>
                            <p class="mb-0">
                                Each meal is carefully crafted with bold, exotic flavors and fresh ingredients, offering a dining experience that stands out from the ordinary
                            </p>
                        </div>
                        <div class="col-sm-4">
                            <img class="img-fluid bg-white w-100" src="@/assets/img/about-6.jpg" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- About End -->


    <!-- Article Start -->
    <div class="container-xxl py-5">
        <div class="container">
            <div class="row g-5">
                <div class="col-lg-5 wow fadeIn" data-wow-delay="0.1s">
                    <img class="img-fluid" src="@/assets/img/article.jpg" alt="">
                </div>
                <div class="col-lg-6 wow fadeIn" data-wow-delay="0.5s">
                    <div class="section-title">
                        <p class="fs-5 fw-medium fst-italic text-primary">Hot & Fast</p>
                        <h1 class="display-6">Fresh Meals Delivered to Your Door, Faster Than You’d Expect</h1>
                    </div>
                    <p class="mb-4">
                        At Bistro Box, we know hunger can’t wait. That’s why we prepare your meals quickly without compromising on taste or quality, ensuring every order arrives piping hot, fresh, and ready to enjoy.
                    </p>
                    <p class="mb-4">
                        And the best part? Our meals are affordable, giving you delicious, satisfying food without breaking the bank. Great taste, fast delivery, and value — all in one box.
                    </p>
                </div>
            </div>
        </div>
    </div>
    <!-- Article End -->


    <!-- Video Start -->
    <div class="container-fluid video my-5">
        <div class="container">
            <div class="row g-0">
                <div class="py-5 wow fadeIn" data-wow-delay="0.1s">
                    <div class="py-5 text-center">
                        <h2>So long as you have food in your mouth, you have solved all questions for the time being."</h2>
                        <p><strong>- Franz Kafka</strong></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Video End -->


    <!-- Store Start -->
    <div class="container-xxl py-5">
        <div class="container">
            <div class="section-title text-center mx-auto wow fadeInUp" data-wow-delay="0.1s" style="max-width: 500px;">
                <p class="fs-5 fw-medium fst-italic text-primary">Online Menu</p>
                <h1 class="display-6">Our Best-Sellers, Your Favorites</h1>
            </div>
            <div class="row g-4">
                <div class="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                    <div class="store-item position-relative text-center">
                        <img class="img-fluid" src="@/assets/img/about-2.jpg" alt="">
                        <div class="p-4">
                            <div class="text-center mb-3">
                                <small class="fa fa-star text-primary"></small>
                                <small class="fa fa-star text-primary"></small>
                                <small class="fa fa-star text-primary"></small>
                                <small class="fa fa-star text-primary"></small>
                                <small class="fa fa-star text-primary"></small>
                            </div>
                            <h4 class="mb-3">Chocolate Milkshake</h4>
                            <p>Rich, creamy, and decadently chocolatey — a classic treat that hits every sweet craving</p>
                            <h4 class="text-primary">₦3,500.00</h4>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
                    <div class="store-item position-relative text-center">
                        <img class="img-fluid" src="@/assets/img/about-1.jpg" alt="">
                        <div class="p-4">
                            <div class="text-center mb-3">
                                <small class="fa fa-star text-primary"></small>
                                <small class="fa fa-star text-primary"></small>
                                <small class="fa fa-star text-primary"></small>
                                <small class="fa fa-star text-primary"></small>
                                <small class="fa fa-star text-primary"></small>
                            </div>
                            <h4 class="mb-3">Strawberry Milkshake</h4>
                            <p>Fresh, fruity, and perfectly sweet — a refreshing strawberry delight in every sip.</p>
                            <h4 class="text-primary">₦3,500.00</h4>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
                    <div class="store-item position-relative text-center">
                        <img class="img-fluid" src="@/assets/img/about-3.jpg" alt="">
                        <div class="p-4">
                            <div class="text-center mb-3">
                                <small class="fa fa-star text-primary"></small>
                                <small class="fa fa-star text-primary"></small>
                                <small class="fa fa-star text-primary"></small>
                                <small class="fa fa-star text-primary"></small>
                                <small class="fa fa-star text-primary"></small>
                            </div>
                            <h4 class="mb-3">Beef Burger</h4>
                            <p>Juicy, perfectly seasoned beef, stacked with fresh toppings and served in a soft, toasted bun — classic comfort in every bite.</p>
                            <h4 class="text-primary">₦3,500.00</h4>
                        </div>
                    </div>
                </div>
                <div class="col-12 text-center wow fadeInUp" data-wow-delay="0.1s">
                    <router-link to="/menu"  class="btn btn-primary rounded-pill py-3 px-5">View More</router-link>
                </div>
            </div>
        </div>
    </div>
    <!-- Store End -->


    <!-- Contact Start -->
    <div class="container-xxl contact py-5">
        <div class="container">
            <div class="section-title text-center mx-auto wow fadeInUp" data-wow-delay="0.1s" style="max-width: 500px;">
                <p class="fs-5 fw-medium fst-italic text-primary">Visit Us</p>
                <h1 class="display-6">
                    Fresh Meals Await at Bistro Box
                </h1>
            </div>
            <div class="row justify-content-center wow fadeInUp" data-wow-delay="0.1s">
                <div class="col-lg-8">
                    <div class="map-container">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3975.706510178296!2d6.993355075813399!3d4.82037164060677!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1069cf001f58b9b3%3A0x4f338fc8e445dadf!2sBistro%20Box!5e0!3m2!1sen!2sng!4v1767618925059!5m2!1sen!2sng" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Contact Start -->
     <a href="#" class="btn btn-lg btn-primary btn-lg-square rounded-circle back-to-top"><i class="bi bi-arrow-up"></i></a>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'
import WOW from 'wowjs'

export default {
  name: 'HomeView',
  setup(){

  // refs
  const spinner = ref(null)
  const backToTop = ref(null)
  const videoIframe = ref(null)
  let videoSrc = ''

  // Spinner
  const hideSpinner = () => {
    setTimeout(() => {
      spinner.value?.classList.remove('show')
    }, 1)
  }

  // Scroll handling
  const handleScroll = () => {
    const scrollTop = window.scrollY

    // Sticky navbar
    const sticky = document.querySelector('.sticky-top')
    if (sticky) {
      if (scrollTop > 300) {
        sticky.classList.add('shadow-sm')
        sticky.style.top = '0px'
      } else {
        sticky.classList.remove('shadow-sm')
        sticky.style.top = '-150px'
      }
    }
  }

    // Smooth scroll to top
    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }

    // Video modal handlers
    const initVideoModal = () => {
      const modal = document.getElementById('videoModal')

      modal?.addEventListener('shown.bs.modal', () => {
        videoIframe.value.src =
          videoSrc +
          '?autoplay=1&modestbranding=1&showinfo=0'
      })

      modal?.addEventListener('hide.bs.modal', () => {
        videoIframe.value.src = videoSrc
      })
    }

    // Capture video src
    const setVideoSrc = (src) => {
      videoSrc = src
    }

    onMounted(() => {
      hideSpinner()

      // WOW.js
      new WOW.WOW({ live: false }).init()

      // Scroll listener
      window.addEventListener('scroll', handleScroll)

      // Modal video
      initVideoModal()
    })

    onUnmounted(() => {
      window.removeEventListener('scroll', handleScroll)
    })
    return{backToTop,scrollToTop,setVideoSrc}
  }
}
</script>
